<template>
    <div>
        <v-btn
            :href="url"
            target="_blank"
            color="amber lighten-1"
            light
            small
        >      <v-icon dark class="mr-2">
            mdi-open-in-new
        </v-icon>
             Pythia
        </v-btn>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
            },
            type: {
                type: String,
                default: 'booking',
            },
        },
        data() {
            return {

            }
        },
        computed: {
            url() {
                switch(this.type) {
                    case 'booking':
                        return this.baseUrl + 'bookings/booking_edit_form/' + this.value + '/'
                    case 'class':
                        return this.baseUrl + 'bookings/class_edit_form/' + this.value + '/'
                    case 'po':
                        return this.baseUrl + 'purchases/po_edit_form/' + this.value + '/'
                    default:
                        return ''
                }
            },

            baseUrl() {
                switch(window.location.host) {
                    case 'helios.systematix.co.uk':
                        return 'https://pythia.systematix.co.uk/'
                    case 'http://dev-helios.systematix.co.uk/':
                        return 'https://dev-pythia.neso.io/'
                    default:
                        return 'http://localhost:8060/'
                }
            }
        },

    }
</script>

<style scoped>

</style>